import React from 'react';
import { withAuthenticationRequired } from '../providers/withAuthenticationRequired';
import TicketOutcomesReport from '../Components/Reports/TicketOutcomesReport';

const AnalyticsPage = () => {
  return (
    <div className="mt-5">
      <TicketOutcomesReport />
    </div>
  );
};

export default withAuthenticationRequired(AnalyticsPage);
